import clsx from "clsx";
import { ComponentPropsWithoutRef } from "react";
import "./tableSectionTitle.scss";

interface ITableSectionTitleProps extends ComponentPropsWithoutRef<"h3"> { }

export const TableSectionTitle = (props: ITableSectionTitleProps) => {
    return <h3 {...props} className={clsx("table-section-title", props.className)} />;
};
